// DO NOT EDIT, GENERATED BY "yarn sheets"

import type { SizeRow } from '../typings';

const data = [
  {
    "id": "junior",
    "name": "Junior",
    "description": "6⅜-7⅛",
    "subset": {
      "modelId": {
        "R16": true,
        "Mach": true,
        "MachAlpha": false,
        "MachCarbon": false,
        "RCFH": false
      }
    }
  },
  {
    "id": "senior",
    "name": "Senior",
    "description": "6⅞-7⅝",
    "subset": {
      "modelId": {
        "R16": true,
        "Mach": true,
        "MachAlpha": false,
        "MachCarbon": false,
        "RCFH": false
      }
    }
  },
  {
    "id": "small",
    "name": "Small",
    "description": "6⅞-7",
    "subset": {
      "modelId": {
        "R16": false,
        "Mach": false,
        "MachAlpha": true,
        "MachCarbon": true,
        "RCFH": false
      }
    }
  },
  {
    "id": "medium",
    "name": "Medium",
    "description": "7⅛-7¼",
    "subset": {
      "modelId": {
        "R16": false,
        "Mach": false,
        "MachAlpha": true,
        "MachCarbon": true,
        "RCFH": false
      }
    }
  },
  {
    "id": "large",
    "name": "Large",
    "description": "7⅜-7½",
    "subset": {
      "modelId": {
        "R16": false,
        "Mach": false,
        "MachAlpha": true,
        "MachCarbon": true,
        "RCFH": false
      }
    }
  },
  {
    "id": "xLarge",
    "name": "X Large",
    "description": "7⅝-7¾",
    "subset": {
      "modelId": {
        "R16": false,
        "Mach": false,
        "MachAlpha": true,
        "MachCarbon": true,
        "RCFH": false
      }
    }
  },
  {
    "id": "oneSize",
    "name": "One Size",
    "description": "6½-7½",
    "subset": {
      "modelId": {
        "R16": false,
        "Mach": false,
        "MachAlpha": false,
        "MachCarbon": false,
        "RCFH": true
      }
    }
  }
] as const;

type Primitive = string | number | boolean | null | undefined;
type Immutable<T> = T extends Primitive
  ? T
  : { readonly [K in keyof T]: Immutable<T[K]> };

type Combine<T extends U, U> = T extends Readonly<Primitive | Primitive[]>
  ? T
  : T extends ReadonlyArray<infer I>
  ? Readonly<Combine<I, Extract<U, Readonly<any[]>>[number]>[]>
  : U extends Readonly<Primitive | any[]>
  ? never
  : string extends keyof U
  ? { [K in keyof T & string]: Combine<T[K], U[K]> }
  : number extends keyof U
  ? { [K in keyof T & number]: Combine<T[K], U[K]> }
  : symbol extends keyof U
  ? { [K in keyof T & symbol]: Combine<T[K], U[K]> }
  : { [K in keyof U]: Combine<T[K], U[K]> };

const typed: Combine<typeof data, Immutable<SizeRow[]>> = data;

export type Size = typeof typed[number];

export const SIZE_INDEX_KEY = "id";
export type SizeIndexKey = "id";
export type SizeId = Size["id"];

let i = 0;
export const SIZE_DICT = {
  "junior": typed[i++],
  "senior": typed[i++],
  "small": typed[i++],
  "medium": typed[i++],
  "large": typed[i++],
  "xLarge": typed[i++],
  "oneSize": typed[i++]
} as const;

export { typed as SIZES };
